export const lessonAnalyticsBranchesMockText = {
  title: 'Lesson 1',
  pickedFirst: 'Picked first:',
  questions: 'Questions',
  branches: 'Branches',
};
